"use strict";

function routeConfig($stateProvider) {
    $stateProvider

        .state("nucont.accounting.group.customization.indicators", {
            url: "/indicadores",
            views: {
                "customizationType@nucont.accounting.group.customization": {
                    component: "indicatorsComponent",
                    bindings: { companyData: "groupData" }
                }
            }
        })
        .state("nucont.accounting.group.customization.graphics", {
            url: "/grafico",
            params: {
                openDialogAdd: {
                    value: null,
                    dynamic: true
                }
            },
            views: {
                "customizationType@nucont.accounting.group.customization": {
                    component: "chartsCustomizationComponent"
                },
                bindings: { companyData: "groupData" }
            },
            resolve: {
                source: [
                    "$stateParams",
                    ($stateParams) => {
                        return $stateParams.source;
                    }
                ]
            }
        })
        .state("nucont.accounting.group.customization.dashboards", {
            url: "/dashboards",
            views: {
                "customizationType@nucont.accounting.group.customization": {
                    component: "customDashboardsComponent"
                },
                bindings: { companyData: "groupData" }
            }
        });
}

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);
